import React, { useEffect, useRef, useState } from "react";
import { Badge } from "@vapor/v3-components";
import { PresentationFilter } from "../pages/PresentationPage";
import useWindowWidth from "../utils/useWindowWidth";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { LinkDocument } from "./LinkDocument";

interface VideoGridProps {
  presentationFilter: PresentationFilter; // Array di URL dei video
  onClickFilter: (idFilter: number) => void;
  onClickDocument?: (
    fileType: string,
    fileNameUrl: string,
    filterNoDownloadVideo: boolean
  ) => void;
}

export const PresentationGrid: React.FC<VideoGridProps> = ({
  presentationFilter,
  onClickFilter,
  onClickDocument,
}) => {
  const { t } = useTranslation();
  const windowWidth: number = useWindowWidth(); // Larghezza della finestra
  //   const cardWidth: number = windowWidth / presentationFilter.numeroColonne; // Math.max((windowWidth - 170) / 4, 150); // Larghezza minima 50px
  //const styleTitle = useRef<string>("");
  const [styleTitle, setStyleTitle] = useState("");

  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLVideoElement, MouseEvent>
  ) => {
    const video = event.currentTarget;
    video.play();
  };

  const handleMouseLeave = (
    event: React.MouseEvent<HTMLVideoElement, MouseEvent>
  ) => {
    const video = event.currentTarget;
    video.pause();
  };

  useEffect(() => {
    if (presentationFilter.stileFilterName) {
      const appStyle: string[] = presentationFilter.stileFilterName.split('"');
      if (appStyle.length > 1) setStyleTitle(appStyle[1]);
    }
  }, [presentationFilter.stileFilterName]);

  const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: theme.palette.getContrastText(theme.palette.common.white),
    backgroundColor: theme.palette.common.white,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    },
  }));

  const onClickDoc = (index: number) => {
    if (onClickDocument)
      onClickDocument(
        presentationFilter.documents[index].documentType,
        presentationFilter.documents[index].documentType === "LINK" ||
          presentationFilter.documents[index].documentType === "YOUTUBE"
          ? presentationFilter.documents[index].fileNameUrl
          : window.config.BASE_URL +
              "/preview/" +
              presentationFilter.documents[index].fileNameUrl,
        presentationFilter.noDownloadVideo
      );
  };
  return (
    <div
      key={presentationFilter.filterId}
      style={{
        // width: `${windowWidth}px`,
        display: "grid",
        gridTemplateColumns: `repeat(${presentationFilter.numeroColonne}, 1fr)`, // Dividi la griglia in 3 colonne
        gap: "0px", // Nessuno spazio tra i video
        position: "relative",
        justifyContent: "center",
      }}
    >
      {presentationFilter.documents.map((doc, index) =>
        index <
        presentationFilter.numeroColonne * presentationFilter.numeroRighe ? (
          <LinkDocument
            index={index}
            documentPreview={window.config.BASE_URL + doc.docImage}
            documentUrl={
              doc.documentType === "LINK" || doc.documentType === "YOUTUBE"
                ? doc.fileNameUrl
                : window.config.BASE_URL + "/preview/" + doc.fileNameUrl
            }
            documentType={doc.documentType}
            onClick={onClickDoc}
            noDownloadVideo={presentationFilter.noDownloadVideo}
          />
        ) : (
          <></>
        )
      )}
      <div
        style={{
          position: "absolute",
          bottom: "100px", // Posizione del titolo sopra il video
          left: "50%",
          transform: "translate(-50%, -50%)", // Centra orizzontalmente
          textAlign: "center",
          width: "90%", // Larghezza del contenitore del testo
        }}
        dangerouslySetInnerHTML={{
          __html: `<span style="${styleTitle}">${presentationFilter.filterName}</span>`,
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          bottom: "50px", // Posizione del titolo sopra il video
          left: "50%",
          transform: "translate(-50%, -50%)", // Centra orizzontalmente
          textAlign: "center",
          width: "90%", // Larghezza del contenitore del testo
        }}
      >
        {/* {localSiteParameters.current.ContPubFiltro && ( */}
        <ColorButton
          size="small"
          variant="contained"
          onClick={() => {
            onClickFilter(presentationFilter.filterId);
          }}
        >
          {t("showAll") + " " + presentationFilter.filterName}
          <Badge
            size="medium"
            sx={{
              mt: -2,
            }}
            variant="standard"
            //          color="info"
            color="counter"
            badgeContent={presentationFilter.TotPub}
          />
        </ColorButton>
      </div>
    </div>
  );
};
